function closeOthers(except: HTMLDetailsElement | null) {
  document
    .querySelectorAll<HTMLDetailsElement>("details[data-autoclose][open]")
    .forEach((d) => {
      if (d !== except) d.open = false
    })
}

document.addEventListener("click", (event) => {
  const inside = (event.target as Element | null)?.closest?.(
    "details[data-autoclose]",
  ) as HTMLDetailsElement | null
  closeOthers(inside)
})

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeOthers(null)
})
